
import { Nav } from './components/nav'
import { Home } from './pages/home'
import { SmoothScroll } from './components/smoothScroll'
import { Preloader } from './components/preloader'

import { PopUp } from './components/popup'
// import { DropDown } from './components/dropdown'

class App {
  constructor() {
    const preloader = new Preloader;
    const nav = new Nav;
    const smoothScroll = new SmoothScroll;

    if (document.querySelector('.template-home')) {
      const home = new Home;
    }

    if (document.querySelector('.popup')) {
      const popup = new PopUp;
    }

    // if(document.querySelector('.dropdown')) {
    //   const dropdown = new DropDown;
    // }
  }
}

window.onload = function() {
  let app = new App();
};
